var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBinary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#6800A8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5492_103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.64969 15.8103C4.52276 15.8103 4.41992 15.7074 4.41992 15.5805V12.8123C4.41992 12.6854 4.52276 12.5825 4.64969 12.5825C4.77662 12.5825 4.87946 12.6854 4.87946 12.8123V15.5805C4.87949 15.7074 4.77659 15.8103 4.64969 15.8103Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.96201 15.81C9.83508 15.81 9.73224 15.7072 9.73224 15.5803V14.2181C9.73224 14.0911 9.83508 13.9883 9.96201 13.9883C10.0889 13.9883 10.1918 14.0911 10.1918 14.2181V15.5803C10.1918 15.7071 10.0889 15.81 9.96201 15.81Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2744 15.81C15.1475 15.81 15.0446 15.7072 15.0446 15.5803V11.5818C15.0446 11.4549 15.1475 11.3521 15.2744 11.3521C15.4013 11.3521 15.5042 11.4549 15.5042 11.5818V15.5803C15.5042 15.7071 15.4013 15.81 15.2744 15.81Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.64969 7.41817C4.52276 7.41817 4.41992 7.3153 4.41992 7.1884V4.4202C4.41992 4.2933 4.52276 4.19043 4.64969 4.19043C4.77662 4.19043 4.87946 4.2933 4.87946 4.4202V7.1884C4.87949 7.3153 4.77659 7.41817 4.64969 7.41817Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.96201 8.82416C9.83508 8.82416 9.73224 8.72129 9.73224 8.59439V4.4202C9.73224 4.2933 9.83508 4.19043 9.96201 4.19043C10.0889 4.19043 10.1918 4.2933 10.1918 4.4202V8.59436C10.1918 8.72126 10.0889 8.82416 9.96201 8.82416Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2744 6.18795C15.1475 6.18795 15.0446 6.08508 15.0446 5.95818V4.4202C15.0446 4.2933 15.1475 4.19043 15.2744 4.19043C15.4013 4.19043 15.5042 4.2933 15.5042 4.4202V5.95818C15.5042 6.08505 15.4013 6.18795 15.2744 6.18795Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.14557 6.9585H3.22977C3.10284 6.9585 3 7.06136 3 7.18827V12.812C3 12.9389 3.10284 13.0417 3.22977 13.0417H6.14557C6.2725 13.0417 6.37534 12.9389 6.37534 12.812V7.18827C6.37534 7.06134 6.27247 6.9585 6.14557 6.9585Z",
    fill: "#FFDB56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.14558 6.9585H5.22647V13.0417H6.14558C6.27251 13.0417 6.37535 12.9389 6.37535 12.812V7.18827C6.37535 7.06134 6.27248 6.9585 6.14558 6.9585Z",
    fill: "#FBA806"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4579 8.36426H8.54209C8.41516 8.36426 8.31232 8.46713 8.31232 8.59403V14.2177C8.31232 14.3446 8.41516 14.4475 8.54209 14.4475H11.4579C11.5848 14.4475 11.6877 14.3446 11.6877 14.2177V8.59405C11.6877 8.46715 11.5848 8.36426 11.4579 8.36426Z",
    fill: "#F77935"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4579 8.36426H10.5388V14.4475H11.4579C11.5848 14.4475 11.6877 14.3446 11.6877 14.2177V8.59405C11.6877 8.46715 11.5848 8.36426 11.4579 8.36426Z",
    fill: "#D9510D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7702 5.72803H13.8544C13.7275 5.72803 13.6247 5.83089 13.6247 5.9578V11.5815C13.6247 11.7084 13.7275 11.8112 13.8544 11.8112H16.7702C16.8972 11.8112 17 11.7084 17 11.5815V5.95782C17 5.83092 16.8971 5.72803 16.7702 5.72803Z",
    fill: "#53DC9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7702 5.72803H15.8511V11.8112H16.7702C16.8972 11.8112 17 11.7084 17 11.5815V5.95782C17 5.83092 16.8971 5.72803 16.7702 5.72803Z",
    fill: "#42B27C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5492_103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinary);
export default __webpack_public_path__ + "static/media/binary.2f42db5edc7f083f21b599d3ba9938fc.svg";
export { ForwardRef as ReactComponent };